module.exports = __webpack_public_path__ + "img/20200804_204135.60226b81.jpg";